#import '../../../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql'

mutation UpdateTask($input: TaskUpdateInput!) {
    taskUpdate(input: $input) {
        task {
            ...CoreEntityTaskFragment
        }
    }
}
